import * as React from 'react';

import { Dialog } from '@longline/aqua-ui/services/Dialog';
import { PrimaryButton } from '@longline/aqua-ui/controls/PrimaryButton';

import { IDriverset } from '../api/models';
import { DriversetEditor } from './DriversetEditor';
import { Pane } from './Pane';

interface IProps {
  driverset: IDriverset;
  onClose: () => void;
  onSave: (driverset: IDriverset) => void;
}

const DriversetEditDialog = (props: IProps) => {
  const driversetRef = React.useRef<IDriverset>({...props.driverset});
  const [valid, setValid] = React.useState(true);

  const handleChange = (ds: IDriverset, isValid: boolean) => {
    Object.assign(driversetRef.current, ds);
    setValid(isValid);
  }

  // canClose={false}: an outside click would discard every edit without asking,
  // and the Excel import report renders inside this dialog, so dismissing the
  // report counted as clicking outside. CANCEL still closes it, because that
  // calls onClose directly.
  return (
    <Dialog width={1200} inverted open canClose={false} onClose={props.onClose}>
      <Dialog.Header>Edit driver set</Dialog.Header>
      <Dialog.Content nopadding>
        <div style={{ height: '500px', overflow: 'hidden', display: 'flex', flexDirection: 'column' }}>
          <DriversetEditor driverset={props.driverset} onChange={handleChange}/>
        </div>
      </Dialog.Content>
      <Dialog.Footer align="space-between">
        <Pane.CancelButton onClick={props.onClose}>CANCEL</Pane.CancelButton>
        <PrimaryButton disabled={!valid} onClick={() => props.onSave(driversetRef.current)}>SAVE</PrimaryButton>
      </Dialog.Footer>
    </Dialog>
  )
}

export { DriversetEditDialog }
